import { UrlPathOfApiLocation } from "common/paths";
import { retrieve } from "framework/http/endpoint";
var ApiUriPrefix = "".concat(UrlPathOfApiLocation, "/api/");
var CountriesApiUri = ApiUriPrefix + "countries";
function apiGetCountries(all, filter) {
    if (all === void 0) { all = false; }
    if (filter === void 0) { filter = null; }
    var filterUri = filter !== null ? '&' + encodeURIComponent(filter) : '';
    var uri = "".concat(CountriesApiUri, "?all=").concat(all).concat(filterUri);
    return retrieve(uri); // retrieveCollection ???
}
export { apiGetCountries, };
